module.exports = __webpack_public_path__ + "img/mycarcheck.553aace8.png";